/** This is used to enable web push notifications */

self.addEventListener("install", () => {
  // Force the waiting service worker to become the active service worker
  (self as any).skipWaiting();
});

self.addEventListener("activate", (event) => {
  // Takes control of the page as soon as it activates
  (event as any).waitUntil((self as any).clients.claim());
});

self.addEventListener("push", async (event) => {
  const data = (event as any).data.json();

  (self as any).registration.showNotification(data.title, {
    body: data.body,
    data: {
      path: data.path || "/",
    },
  });

  if (navigator.setAppBadge && data.badgeCount) {
    navigator.setAppBadge(data.badgeCount);
  }

  notifyWebApp();
});

self.addEventListener("notificationclick", (event) => {
  const notification = (event as any).notification;
  const path = notification.data?.path || "/";

  notification.close();

  (event as any).waitUntil(
    (self as any).clients
      .matchAll({ type: "window", includeUncontrolled: true })
      .then((clientList) => {
        // Check if there's already a window open
        for (const client of clientList) {
          if (client.url.includes(self.location.origin) && "focus" in client) {
            // Try to navigate the existing window
            // Note: client.navigate() doesn't work on iOS PWAs
            if ("navigate" in client) {
              client.navigate(self.location.origin + path);
              return client.focus();
            } else {
              // For iOS PWAs, send a message to the client to navigate
              client.postMessage({
                type: "NOTIFICATION_CLICKED",
                path: path,
              });
              return client.focus();
            }
          }
        }
        // If no window is open, open a new one
        if ((self as any).clients.openWindow) {
          return (self as any).clients.openWindow(path);
        }
      })
  );
});

/** Notify any browser tabs which are currently open that a notification has been received */
const notifyWebApp = () => {
  (self as any)?.clients
    ?.matchAll({ type: "window", includeUncontrolled: true })
    .then((clients) => {
      for (let client of clients) {
        client.postMessage({
          type: "PUSH_NOTIFICATION_RECEIVED",
        });
      }
    });
};
